import { render, staticRenderFns } from "./BindingChangeDialog.vue?vue&type=template&id=7ca5223b"
import script from "./BindingChangeDialog.vue?vue&type=script&lang=js"
export * from "./BindingChangeDialog.vue?vue&type=script&lang=js"
import style0 from "./styles/change-dialog.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./styles/game-list.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports